// temp disable travel distance request on all but initial spots
// import {getTravelDistances} from 'spots/spots-actions';
import SearchAPI from 'api/search';

export const SEARCH_SUBMIT = 'SEARCH_SUBMIT';
export const SEARCH_GET_AIRPORTS = 'SEARCH_GET_AIRPORTS';
export const SEARCH_SET_SORT_TYPE = 'SEARCH_SET_SORT_TYPE';
export const SEARCH_UPDATE_TIMES = 'SEARCH_UPDATE_TIMES';
export const SEARCH_TOGGLE_LIST_VIEW = 'SEARCH_TOGGLE_LIST_VIEW';
export const SEARCH_TOGGLE_INFO_PANEL_VIEW = 'SEARCH_TOGGLE_INFO_PANEL_VIEW';
export const SEARCH_TOGGLE_FILTERS_VIEW = 'SEARCH_TOGGLE_FILTERS_VIEW';
export const SEARCH_SET_MAP_INSTANCE = 'SEARCH_SET_MAP_INSTANCE';
export const SEARCH_SET_ZOOM = 'SEARCH_SET_ZOOM';
export const SEARCH_TOGGLE_MOBILE_LIST_VIEW_ACTIVE =
    'SEARCH_TOGGLE_MOBILE_LIST_VIEW_ACTIVE';

export const getAirports = () => {
    return (dispatch, getState) => {
        dispatch({
            type: SEARCH_GET_AIRPORTS,
            payload: SearchAPI.getAirports(),
        });
    };
};

export const setSortType = sortBy => {
    return dispatch => {
        dispatch({
            type: SEARCH_SET_SORT_TYPE,
            payload: {
                sortBy,
            },
        });

        // temp disable travel distance request on all but initial spots
        // getTravelDistances(dispatch)
        //     .catch(error => {
        //         // silently catch this error to ignore errors being logged
        //     });
    };
};

export const toggleListView = () => {
    return {
        type: SEARCH_TOGGLE_LIST_VIEW,
    };
};

export const toggleInfoPanelView = isInfoPanelVisible => {
    return {
        type: SEARCH_TOGGLE_INFO_PANEL_VIEW,
        payload: {
            isInfoPanelVisible,
        },
    };
};

export const toggleFiltersView = () => {
    return {
        type: SEARCH_TOGGLE_FILTERS_VIEW,
    };
};

export const toggleMobileListView = isMobileListViewActive => {
    return {
        type: SEARCH_TOGGLE_MOBILE_LIST_VIEW_ACTIVE,
        payload: {
            isMobileListViewActive,
        },
    };
};

export const setSearchMapInstance = searchMapInstance => {
    return {
        type: SEARCH_SET_MAP_INSTANCE,
        payload: {
            searchMapInstance,
        },
    };
};

export const setZoom = zoom => {
    return {
        type: SEARCH_SET_ZOOM,
        payload: {
            zoom,
        },
    };
};
